import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import ChevronLeft from '@mui/icons-material/ChevronLeft';
import ChevronRight from '@mui/icons-material/ChevronRight';
import type { ChangeEvent, FC } from 'react';

import { setMonth, getMonth, setYear, getYear } from '../utils';

interface HeaderProps {
  date: Date;
  setDate: (date: Date) => void;
  nextDisabled: boolean;
  prevDisabled: boolean;
  onClickNext: () => void;
  onClickPrevious: () => void;
}

const MONTHS = [
  'Ene',
  'Feb',
  'Mar',
  'Abr',
  'May',
  'Jun',
  'Jul',
  'Ago',
  'Sept',
  'Oct',
  'Nov',
  'Dic'
];

const generateYears = (relativeTo: Date, count: number) => {
  const half = Math.floor(count / 2);
  return Array(count)
    .fill(0)
    .map((y, i) => relativeTo.getFullYear() - half + i); // TODO: make part of the state
};

const stylesBuilder = () => ({
  iconContainer: {
    padding: '5px'
  },
  icon: {
    padding: '10px',
    '&:hover': {
      background: 'none'
    }
  }
});

const Header: FC<HeaderProps> = ({
  date,
  setDate,
  nextDisabled,
  prevDisabled,
  onClickNext,
  onClickPrevious
}: HeaderProps) => {
  const styles = stylesBuilder();

  const handleMonthChange = (event: ChangeEvent<{ value: unknown }>) => {
    setDate(setMonth(date, parseInt(event.target.value as string)));
  };

  const handleYearChange = (event: ChangeEvent<{ value: unknown }>) => {
    setDate(setYear(date, parseInt(event.target.value as string)));
  };

  return (
    <Grid alignItems="center" justifyContent="space-between" container>
      <Grid sx={{ ...styles.iconContainer }} item>
        <IconButton
          disabled={prevDisabled}
          onClick={onClickPrevious}
          sx={{ ...styles.icon }}
        >
          <ChevronLeft color={prevDisabled ? 'disabled' : 'action'} />
        </IconButton>
      </Grid>
      <Grid item>
        <Select
          MenuProps={{ disablePortal: true }}
          onChange={handleMonthChange}
          value={getMonth(date)}
        >
          {MONTHS.map((month, idx) => (
            <MenuItem key={month} value={idx}>
              {month}
            </MenuItem>
          ))}
        </Select>
      </Grid>

      <Grid item>
        <Select
          MenuProps={{ disablePortal: true }}
          onChange={handleYearChange}
          value={getYear(date)}
        >
          {generateYears(date, 30).map((year) => (
            <MenuItem key={year} value={year}>
              {year}
            </MenuItem>
          ))}
        </Select>
      </Grid>
      <Grid sx={{ ...styles.iconContainer }} item>
        <IconButton
          disabled={nextDisabled}
          onClick={onClickNext}
          sx={{ ...styles.icon }}
        >
          <ChevronRight color={nextDisabled ? 'disabled' : 'action'} />
        </IconButton>
      </Grid>
    </Grid>
  );
};
export default Header;
